import { useSelector, useDispatch } from 'react-redux';
import { getFooter, getIsLoading, fetchFooter } from './index';
import { useLayoutEffect } from 'react';
import { useConfig } from 'client/config';

export const useFooterWithPrefetch = (locale?: string) => {
    const dispatch = useDispatch();
    const footer = useSelector(getFooter);
    const isLoading = useSelector(getIsLoading);

    const config = useConfig();

    useLayoutEffect(() => {
        if (config.isEnabled('footer') && !footer && !isLoading) {
            dispatch(fetchFooter(locale));
        }
    }, []);

    return footer;
};
